import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectOrder(data) {
  return request({
    url: `/admin/mall/order/selectOrder`,
    method: "POST",
    data,
  });
}


/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addOrder(data) {
  return request({
    url: `/admin/mall/order/addOrder`,
    method: "POST",
    data,
  });
}

/**
 * 更改
 * @param {*} data
 * @returns
 */
export function updateOrder(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/mall/order/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteOrder(data) {
  return request({
    url: `/admin/mall/order/delete`,
    method: "POST",
    data,
  });
}


/**
 * 发货
 * @param {*} data
 * @returns
 */
export function updateProduct(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/mall/order/updateProduct`,
    method: "POST",
    data,
  });
}
